module.exports = __webpack_public_path__ + "static/media/fit.13233193.png";